import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

export function formatDateWithTimezone(input: string, tz: string = "Europe/Moscow"): string {
  const [date, time] = input.split(" ")
  const [day, month, year] = date.split(".")
  const formatted = `${year}-${month}-${day}T${time}:00`
  return dayjs.tz(formatted, tz).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
}
